import { runtimeEnv } from "config/runtimeEnv";
import { call, put, takeEvery } from "redux-saga/effects";
import {GET_LOGIN_SUCCESS, GET_LOGIN_FAILED, GET_LOGIN_REQUESTED, GET_MAGICTOKEN_SUCCESS, GET_MAGICTOKEN_FAILED, GET_MAGICTOKEN_REQUESTED, GET_TOKENVERIFY_SUCCESS, GET_TOKENVERIFY_FAILED, GET_TOKENVERIFY_REQUESTED} from "resources/actionTypes";
import { loginApi, magicTokenApi, tokenVerifyApi } from "services/LoginService";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from "redux/store";
import { getProfile } from "redux/actions/UserProfile";
import { onLoaderTrigger } from "redux/actions/CommonAction";

function* fetchLogin(action) {
  const payload = action.payload || {}
  const userLogin = yield call(loginApi, payload?.loginPayload?.userDetails);
  if(userLogin.success){
    yield put({ type: GET_LOGIN_SUCCESS, userLogin: userLogin });

    if(payload?.loginPayload?.actionType === "login") {
      payload?.setOnOtp(true);

      const userDetails = {
        mobile: payload?.loginPayload?.userDetails?.mobileOrEmail,
        code: payload?.loginPayload?.userDetails?.countryCode
      }

      localStorage.setItem('loginDetails', JSON.stringify(userDetails));
    }
    
    toast.success(userLogin.message);
  }else{
    yield put({ type: GET_LOGIN_FAILED, message: userLogin.message });
      toast.error(userLogin.message || 'Login failed');
  }
}
export function* loginSaga() {
  yield takeEvery(GET_LOGIN_REQUESTED, fetchLogin);
}

function* fetchMagicToken(action) {
  const payload = action.payload || {}
  const userMagicToken = yield call(magicTokenApi, payload.userMagicToken);
  if(userMagicToken.success){
    yield put({ type: GET_MAGICTOKEN_SUCCESS, userMagicToken: userMagicToken });
    toast.success(userMagicToken?.message);
    window.open(`${runtimeEnv("B2B_DOMAIN")+'/login?magicToken='+userMagicToken?.token}`, "_blank")
  }else{
    yield put({ type: GET_MAGICTOKEN_FAILED, message: userMagicToken.message });
    toast.error(userMagicToken.message || 'MagicToken failed');
  }
}
export function* magicTokenSaga() {
  yield takeEvery(GET_MAGICTOKEN_REQUESTED, fetchMagicToken);
}

function* fetchTokenVerify(action) {
  const payload = action.payload || {}
  const userTokenVerify = yield call(tokenVerifyApi, payload.userTokenVerify);
  if(userTokenVerify.success){
    localStorage.setItem('token', userTokenVerify?.token)
    yield put({ type: GET_TOKENVERIFY_SUCCESS, userTokenVerify: userTokenVerify });
    toast.success(userTokenVerify?.message);
    store.dispatch(getProfile({tabType:'auth'}));
  }else{
    yield put({ type: GET_TOKENVERIFY_FAILED, message: userTokenVerify.message });
    toast.error(userTokenVerify.message || 'TokenVerify failed');
  }
}
export function* tokenVerifySaga() {
  yield takeEvery(GET_TOKENVERIFY_REQUESTED, fetchTokenVerify);
}
